import { Padding } from "@mui/icons-material";
import React from "react";

const ProgressBar = ({ bgColor, completed }) => {
  const wrapperStyles = {
    height: "12px",
    width: "100%",
    flexDirection: "row",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    // borderRight: "2px solid #666666",
    Padding: "20px 0px",
  };

  const containerStyles = {
    minWidth: "150px",
    width: "100%",
    backgroundColor: "#D6D6D9",
    borderRadius: "8px",
  };

  const fillerStyles = {
    height: "8px",
    width: `${completed}%`,
    maxWidth: "100%",
    backgroundColor: bgColor,
    borderRadius: "8px",
  };

  return (
    <div
      key={completed}
      style={wrapperStyles}
      className="container-progressBar"
    >
      <div style={containerStyles} className="progressBarBackground">
        <div style={fillerStyles}></div>
      </div>
    </div>
  );
};

export default ProgressBar;
